const UserPop = ({ courseAttendee }) => {
    return (
        <div className="courses_user_counter_table_model">
            <div className="table_responsive fullWidth vert_scroll">
                <table className="table">
                    <tbody>
                        <tr>
                            <th><p>Email</p></th>
                            <th><p>First Name</p></th>
                            <th><p>Last Name</p></th>
                            <th><p>Alumni</p></th>
                            <th><p>Membership</p></th>
                        </tr>
                        {
                            courseAttendee.map( data => (
                                <tr>
                                    <td>{data.email}</td>
                                    <td>{data.first_name}</td>
                                    <td>{data.last_name}</td>
                                    <td>{data.email.includes('@alumni.usc.edu') ? "Yes" : "No"}</td>
                                    <td>{data.membership}</td>
                                </tr>
                                )
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default UserPop